module.exports = __webpack_public_path__ + "static/demo-hidden-bar-89f1085db5950b4c140303168113257d.mp4";